import { dispatchSetIsIframeShared } from 'store/dispatcher'

import { IFRAME, VIDEO_CALL } from './constants'

export const roomStateHandler = message => {
    const { state, data } = message

    if (state === IFRAME) {
        dispatchSetIsIframeShared({ isShared: true, urlData: data })
    }
    if (state === VIDEO_CALL) {
        dispatchSetIsIframeShared({
            isShared: false,
            urlData: { teacher_url: '', student_url: '' },
        })
    }
}
